import React from "react";
import styled, { StyledComponent } from "styled-components";
import { Badge } from "./Badge";

const A = styled.a`
  line-height: 2px;
  text-decoration: none;
`;

export const BookTicket = ({
  data,
  space,
  heading,
  fullWidth,
  WrapWith,
  digitalEvent,
}: {
  data: any;
  space: number;
  heading: string;
  digitalEvent?: boolean;
  fullWidth?: boolean;
  WrapWith?: StyledComponent<any, any>;
}) => {
  let out: any;

  try {
    if (typeof data?.acf?.date_end === "string" && data?.acf?.date_end.trim()) {
      const today = new Date();
      today.setHours(0, 0, 0, 0);

      const end = new Date(data?.acf?.date_end);
      end.setHours(0, 0, 0, 0);

      if (end < today) return <></>;
    }
  } catch (err: any) {
    return <></>;
  }

  const hasUrl = data?.acf?.ticket_url && data?.acf?.ticket_url.trim();

  if (hasUrl) {
    if (data?.acf?.sold_out) {
      out = (
        <Badge space={space} heading={heading} fullWidth={fullWidth}>
          SOLD OUT
        </Badge>
      );
    } else {
      out = (
        <A
          href={data?.acf?.ticket_url}
          target="_blank"
          rel="noreferrer"
          title="book tickets"
        >
          <Badge space={space} heading={heading} fullWidth={fullWidth}>
            {data?.acf?.free_event === false || fullWidth
              ? "BOOK TICKETS"
              : "FREE, BOOKING ESSENTIAL"}
          </Badge>
        </A>
      );
    }
  } else {
    out = (
      <Badge space={space} heading={heading} fullWidth={fullWidth}>
        FREE
      </Badge>
    );
  }

  if (out) return WrapWith ? <WrapWith>{out}</WrapWith> : out;

  return <></>;
};
